var filter = function () {
    return function (input) {
        return input !== 'Long Term' ? input = input + " months" : input;
    };
};
var ɵ0 = filter;
export var ContractDurationFilter = {
    name: 'contractDuration',
    filter: filter
};
export { ɵ0 };
//# sourceMappingURL=contract-duration.filter.js.map